import { OUTLOOK_ADDIN_TITLE_ID } from "owa-copilot-settings-store";
import { type LocalizedString, format } from "owa-localize";
import { getStringsForScenarioAndTitleId, type AddinRelatedCopilotFeatures, } from "./getAddinsAvailableForFeature";
import { type MailboxInfo } from "owa-client-types";

export function getAddinPickerTeachingBubbleMessage(currentAddinId: string | undefined, scenarioName: AddinRelatedCopilotFeatures, outlookModeMessage: LocalizedString, addinModeGenericMessage: LocalizedString, mailboxInfo: MailboxInfo): LocalizedString {
    if (currentAddinId !== OUTLOOK_ADDIN_TITLE_ID) {
        const addinName = !!currentAddinId
            ? getStringsForScenarioAndTitleId(scenarioName, currentAddinId, mailboxInfo)
                ?.fallbackAddinName
            : undefined;
        if (addinName) {
            return format(addinModeGenericMessage, addinName);
        }
    }
    
    return outlookModeMessage;
}
